import type { Tone } from '@/lib/programs'

export const TONE_PILL: Record<Tone, string> = {
  primary: 'bg-light-purple-3 text-dark-purple',
  success: 'bg-light-green text-dark-blue',
  warning: 'bg-warning/15 text-dark-blue',
  error: 'bg-red/10 text-red',
  muted: 'bg-beige text-dark-blue/70',
}

export function StatusPill({ label, tone }: { label: string; tone: Tone }) {
  return (
    <span className={`inline-flex h-8 shrink-0 items-center rounded-full px-4 text-13 font-bold ${TONE_PILL[tone]}`}>
      {label}
    </span>
  )
}
